import { Flex } from '@mantine/core';
import { DrawnSignatureSource } from '@dealstack/shared/lib/common/eideasy/signingMethods';
import { useTranslationCommonUi } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { SignDrawBody } from './SignDrawBody';
import { StepBody } from './StepBody';
import { StepFooter } from './StepFooter';
import { StepHeader } from './StepHeader';
import { StepHeading, StepSubHeading } from './typography';

interface Props {
	onConfirmSignature: (signatureDataUrl: string, source: DrawnSignatureSource) => void;
	onGoBack: () => void;
	/**
	 * When true, skip the saved-signature pre-step and skip auto-saving the new signature.
	 * Used for witness signing — the actor's saved profile signature is not the witness's
	 * signature, and witnesses should sign fresh each time.
	 */
	disableSavedSignature?: boolean;
	hideStepHeader?: boolean;
}

export const SignDrawStep = ({
	onConfirmSignature,
	onGoBack,
	disableSavedSignature = false,
	hideStepHeader,
}: Props) => {
	const tCommonUi = useTranslationCommonUi();

	return (
		<Flex direction="column" w="100%" h="100%">
			{!hideStepHeader && <StepHeader onGoBack={onGoBack} />}
			<StepBody>
				<Flex direction="column" gap={4}>
					<StepHeading>{tCommonUi('eid_easy_signing.sign_draw_prompt')}</StepHeading>
					<StepSubHeading>{tCommonUi('eid_easy_signing.ses_disclaimer')}</StepSubHeading>
				</Flex>
				<SignDrawBody
					onConfirmSignature={onConfirmSignature}
					disableSavedSignature={disableSavedSignature}
				/>
			</StepBody>
			<StepFooter>{null}</StepFooter>
		</Flex>
	);
};
